// extracted by mini-css-extract-plugin
export default {"button-primary":"ButtonPrimary_button-primary__Mr49D"};